import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {ColNativeServiceApi} from "../col-native-api";
import {ApiLearningUnitTeacher, ApiLessonInstance, ApiPersonalProfile,} from "src/app/col/model/rest-model";

@Injectable({
  providedIn: "root",
})
export class UnsupportedColNativeServiceApi implements ColNativeServiceApi {
  createVideoClassroom(teacherId: number, lessonId: number): Observable<ApiLessonInstance<ApiPersonalProfile, ApiLearningUnitTeacher>> {
    throw new Error("Method not implemented.");
  }


}
